import React, { memo } from 'react'
import { Image } from '@/components/ui'
import type { ILandingListInformationProps } from './types'
import './styles.scss'

const LandingListInformation: React.FC<ILandingListInformationProps> = props => {
  const { title, description, lists, imageSrc } = props

  return (
    <div className="page-wrapper">
      <div className="landingListInformation">
        <h2>{title}</h2>

        {description && <div className="landingListInformation__description h3">{description}</div>}

        <div className="landingListInformation__container">
          {!!lists.length && (
            <ul className="landingListInformation__list">
              {lists.map((itemLists, indexList) => (
                <div key={`${itemLists.title}${indexList}`} className="landingListInformationItem">
                  {itemLists.title && <h3>{itemLists.title}</h3>}
                  {!!itemLists.list?.length && (
                    <ul>
                      {itemLists.list.map((item, indexItem) => (
                        <li key={`${item}${indexItem}`}>{item}</li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </ul>
          )}

          <div className="landingListInformation__image">
            <Image src={imageSrc} isInStatic />
          </div>
        </div>
      </div>
    </div>
  )
}

export default memo(LandingListInformation)
